export const getUnicValuesArr = <T extends Iterable<unknown>>(
  payload: T,
): unknown[] => {
  return [...new Set(payload)];
};
